export default {
  name: "AgreeMent"
};